<template>
  <div id="store-selector-box">
    <h2>Change Active Store</h2>
    <div class="stores-box">
      <div
        v-for="store in stores"
        :key="store.code"
        class="store-box flex flex-row h-14"
        @click="updateStoreSelected(store.code)"
      >
        <img
          v-if="selectedStore == store.code"
          class="selected mr-4"
          src="@/assets/icons/check.svg"
        />
        {{ store.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    stores() {
      return this.$store.getters["general/getStores"];
    },
    selectedStore() {
      return this.$store.getters["general/getActiveStore"]?.code;
    }
  },
  methods: {
    async updateStoreSelected(storeCode) {
      let params = { ...this.$route.params };
      if (storeCode != params.storeCode) {
        params.storeCode = storeCode;
        params.departmentCode = "all";

        await this.$store.dispatch("general/setStore", {
          newStore: storeCode,
          departmentCode: "all"
        });

        const routeName = this.$route.name || "DashboardPage";
        this.$router.push({ name: routeName, params }).catch(err => {
          if (err.name !== "NavigationDuplicated") {
            console.error("Navigation error:", err);
          }
        });
      }
      this.$emit("selected");
    }
  }
};
</script>
<style lang="scss">
#store-selector-box {
  color: black;
  text-align: center;
  .stores-box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .store-box {
      border: 1px solid #808080;
      border-radius: 7px;
      padding: 20px;
      margin: 20px;
      text-align: center;
      -webkit-box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.53);
      -moz-box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.53);
      box-shadow: 3px 3px 3px 1px rgba(0, 0, 0, 0.53);
      &:hover {
        background-color: #126e6a;
        color: white;
      }
      img.selected {
        width: 20px;
      }
    }
  }
}
</style>
